// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3B-Ju","tab":"Tabs_tab__2-FnL","tabActive":"Tabs_tabActive__v3CcP"};